import { render, staticRenderFns } from "./ShowDeletedButton.vue?vue&type=template&id=1eb9241f&"
import script from "./ShowDeletedButton.vue?vue&type=script&lang=ts&"
export * from "./ShowDeletedButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports